"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AboutScreen = void 0;
const zimporter_phaser_1 = require("zimporter-phaser");
const GlobalData_1 = require("./GlobalData");
class AboutScreen {
    constructor(phaserScene, onClose) {
        this.phaserScene = phaserScene;
        this.onClose = onClose;
        this.scene = new zimporter_phaser_1.ZScene('about', phaserScene);
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            yield new Promise(resolve => {
                this.scene.load(`${GlobalData_1.GlobalData.assetsBasePath}about/`, () => resolve());
            });
            zimporter_phaser_1.ZSceneStack.push(this.scene);
            this.scene.loadStage(this.phaserScene);
            const L = GlobalData_1.GlobalData.labels;
            const ss = this.scene.sceneStage;
            (_a = ss.get('aboutTopTitleTXT')) === null || _a === void 0 ? void 0 : _a.setText((_b = L['about']) !== null && _b !== void 0 ? _b : 'About');
            (_c = ss.get('myText')) === null || _c === void 0 ? void 0 : _c.setText((_d = L['aboutcontents']) !== null && _d !== void 0 ? _d : '');
            const xBtn = ss.get('xButton');
            if (xBtn) {
                xBtn.setCallback(() => this._close());
            }
        });
    }
    _close() {
        const xBtn = this.scene.sceneStage.get('xButton');
        xBtn === null || xBtn === void 0 ? void 0 : xBtn.removeCallback();
        GlobalData_1.GlobalData.playUiSound('xClose.mp3');
        zimporter_phaser_1.ZSceneStack.pop();
        if (this.scene.sceneStage.parentContainer) {
            this.scene.sceneStage.parentContainer.remove(this.scene.sceneStage);
        }
        this.scene.destroy();
        this.onClose();
    }
}
exports.AboutScreen = AboutScreen;
